import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, TBody, TR, TD } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { PRIMARY_COLOR } from '../../../constants';
import { textStyle } from '../../../helpers/getEmailStyles';

class BookingExpiredGuest extends Component {
	static propTypes = {
		content: PropTypes.shape({
			listTitle: PropTypes.string.isRequired,
			guestName: PropTypes.string.isRequired,
			checkIn: PropTypes.string.isRequired,
			confirmationCode: PropTypes.number.isRequired,
		}).isRequired
	};

	render() {
		const { content: { guestName, listTitle, confirmationCode, checkIn, logo, siteName } } = this.props;
		let checkInDate = checkIn != null ? moment(checkIn).format('DD-MM-YYYY h:mm A') : '';
		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor="#F7F7F7" logo={logo} siteName={siteName} />
				<div>
					<Table width="100%" >
						<TBody>
							<TR>
								<TD style={textStyle}>
									<EmptySpace height={20} />
									<div>
										Hola {guestName},
									</div>
									<EmptySpace height={20} />
									<div>
										Lamentamos informarle que la solicitud en {listTitle}
										{' '}{confirmationCode} a partir del {checkInDate} ha caducado. se le reembolsará en su totalidad y se le notificará.
									</div>
									<EmptySpace height={40} />
									<EmailSignature siteName={siteName} />
								</TD>
							</TR>
						</TBody>
					</Table>
					<EmptySpace height={40} />
				</div>
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}
}

export default BookingExpiredGuest;
